import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";
import Home from "./pages/Home";
import Cart from "./pages/Cart";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AdminOrders from "./pages/AdminOrders";
import Navbar from "./components/Navbar";

function App() {
  const [cart, setCart] = useState([]);
  const [user, setUser] = useState(() => {
    try {
      const savedUser = localStorage.getItem("user");
      return savedUser ? JSON.parse(savedUser) : null;
    } catch {
      return null;
    }
  });

  const addToCart = (product) => {
    const exist = cart.find((x) => x._id === product._id);
    if (exist) {
      setCart(cart.map((x) => x._id === product._id ? { ...exist, qty: exist.qty + 1 } : x));
    } else {
      setCart([...cart, { ...product, qty: 1 }]);
    }
  };

  const decreaseQuantity = (productId) => {
    const exist = cart.find((x) => x._id === productId);
    if (exist.qty === 1) {
      setCart(cart.filter((x) => x._id !== productId));
    } else {
      setCart(cart.map((x) => x._id === productId ? { ...exist, qty: exist.qty - 1 } : x));
    }
  };

  const removeFromCart = (productId) => {
    setCart(cart.filter((x) => x._id !== productId));
  };

  const cartCount = cart.reduce((acc, item) => acc + item.qty, 0);

  return (
    <Router>
      <div className="min-h-screen flex flex-col font-sans bg-slate-50 text-slate-900">
        <Navbar cartCount={cartCount} user={user} setUser={setUser} />
        <main className="flex-grow max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8">
          <Routes>
            <Route path="/" element={<Home cart={cart} addToCart={addToCart} decreaseQuantity={decreaseQuantity} />} />
            <Route path="/cart" element={<Cart cart={cart} addToCart={addToCart} decreaseQuantity={decreaseQuantity} removeFromCart={removeFromCart} user={user} setCart={setCart} />} />
            <Route path="/login" element={<Login setUser={setUser} />} />
            <Route path="/register" element={<Register setUser={setUser} />} />
            <Route path="/admin/orders" element={<AdminOrders user={user} />} />
          </Routes>
        </main>
        <footer className="bg-white border-t border-slate-100 py-8 text-center text-slate-500 mt-auto">
          <p className="font-medium">&copy; {new Date().getFullYear()} ShopSwift. All rights reserved.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
